/*
Defines the custom element <ravel-gadget>
*/

import { RavelGadget } from './src/RavelGadget.js';

customElements.define('ravel-gadget', RavelGadget);
